import Footer from '../components/Footer';

const $footer = document.querySelector('.js-footer');

if ($footer) {
  const footer = new Footer($footer);
  footer.mount();
}
